module.exports = __webpack_public_path__ + "static/Snake-da4c8736103987e343ff9436e3b2409e.pdf";